// VRT related-products loader. The `recommendations` object is empty on a normal
// product page load, so this element lazily fetches its own section through the
// product-recommendations route (which populates recommendations server-side) and
// swaps the freshly rendered grid in. Hides the section when there's nothing to
// recommend or the fetch fails.

class VrtRelated extends HTMLElement {
  connectedCallback() {
    if (this.dataset.performed === 'true') return;
    this.observer = new IntersectionObserver(
      (entries, obs) => {
        if (!entries[0]?.isIntersecting) return;
        obs.disconnect();
        this.load();
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  async load() {
    const grid = this.querySelector('[data-vrt-related-grid]');
    try {
      const res = await fetch(this.dataset.url);
      if (!res.ok) return this.fail();
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const fresh = doc.querySelector('[data-vrt-related-grid]');
      if (!fresh || !grid) return this.fail();
      // Skeletons carry no product cards; an empty fresh grid means no recs.
      if (fresh.querySelector('.vrt-pcard') === null) return this.fail();
      grid.innerHTML = fresh.innerHTML;
      this.dataset.performed = 'true';
    } catch (e) {
      this.fail();
    }
  }

  fail() {
    this.hidden = true;
  }
}

if (!customElements.get('vrt-related')) {
  customElements.define('vrt-related', VrtRelated);
}
